import { render, staticRenderFns } from "./InstalledPrinterEditInline.vue?vue&type=template&id=21a2a950&scoped=true&"
import script from "./InstalledPrinterEditInline.vue?vue&type=script&lang=js&"
export * from "./InstalledPrinterEditInline.vue?vue&type=script&lang=js&"
import style0 from "./InstalledPrinterEditInline.vue?vue&type=style&index=0&id=21a2a950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2a950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VRow,VSelect,VTextField})
